import React from 'react';
import PropTypes from 'prop-types';
import TextTransition from 'react-text-transition';
import classNames from 'classnames';
import {
    FacebookShareButton,
    FacebookIcon,
    EmailShareButton,
    EmailIcon,
    TwitterShareButton,
    TwitterIcon,
    LinkedinShareButton,
    LinkedinIcon,
} from 'react-share';

const ShareNavConfig = ({ socialConfig, labels, isLightBox, title, goBack, goForward }) => (
    <React.Fragment>
        {isLightBox && title && (
            <div className="title light-box">
                <TextTransition text={title} spring={{ stiffness: 120, damping: 17 }} />
            </div>
        )}
        {socialConfig.socialShareUrl && (
            <div
                className={classNames('social-share', {
                    'light-box': isLightBox,
                })}
            >
                <EmailShareButton
                    subject={socialConfig.socialShareTitle}
                    body={socialConfig.socialShareBody}
                    url={socialConfig.socialShareUrl}
                >
                    <EmailIcon size={28} />
                    <span className="share-text">{labels.socialShare}</span>
                </EmailShareButton>
                <TwitterShareButton
                    url={socialConfig.socialShareUrl}
                    title={socialConfig.socialShareTitle}
                    hashtag={socialConfig.socialShareHashTag}
                >
                    <TwitterIcon size={28} />
                    <span className="share-text">{labels.socialTweet}</span>
                </TwitterShareButton>
                <FacebookShareButton url={socialConfig.socialShareUrl} quote={socialConfig.socialShareTitle}>
                    <FacebookIcon size={28} />
                    <span className="share-text">{labels.socialLikeIt}</span>
                </FacebookShareButton>
                <LinkedinShareButton url={socialConfig.socialShareUrl}>
                    <LinkedinIcon size={28} />
                    <span className="share-text">{labels.socialLinkIt}</span>
                </LinkedinShareButton>
            </div>
        )}
        <div
            className={classNames('nav-buttons', {
                'light-box': isLightBox,
            })}
        >
            <button className="prev" onClick={goBack} title={labels.previous}>
                <i className="arrow left" />
            </button>
            <button className="next" onClick={goForward} title={labels.next}>
                <i className="arrow right" />
            </button>
        </div>
    </React.Fragment>
);

ShareNavConfig.propTypes = {
    goBack: PropTypes.func.isRequired,
    goForward: PropTypes.func.isRequired,
    isLightBox: PropTypes.bool,
    labels: PropTypes.shape({
        next: PropTypes.string,
        previous: PropTypes.string,
        socialLikeIt: PropTypes.string,
        socialLinkIt: PropTypes.string,
        socialShare: PropTypes.string,
        socialTweet: PropTypes.string,
    }),
    socialConfig: PropTypes.shape({
        socialShareBody: PropTypes.string,
        socialShareHashTag: PropTypes.string,
        socialShareTitle: PropTypes.string,
        socialShareUrl: PropTypes.string,
    }),
    title: PropTypes.string,
};

ShareNavConfig.defaultProps = {
    isLightBox: false,
    title: '',
    socialConfig: {}
};

export default ShareNavConfig;
